/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Audit_ActorInputs */

const cs_gdpr_audit_actor = /** @type {(inputs: Gdpr_Audit_ActorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID uživatele`)
};

const en_gdpr_audit_actor = /** @type {(inputs: Gdpr_Audit_ActorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User ID`)
};

/**
* | output |
* | --- |
* | "User ID" |
*
* @param {Gdpr_Audit_ActorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_audit_actor = /** @type {((inputs?: Gdpr_Audit_ActorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Audit_ActorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_audit_actor(inputs)
	return cs_gdpr_audit_actor(inputs)
});